// 自定義 SVG 圖標組件
export const WaterIcon = () => (
  <img
    src="/assets/icons/water.svg"
    alt="water"
    width="16"
    height="16"
    className="w-4 h-4"
  />
);

export const BagIcon = () => (
  <img
    src="/assets/icons/bag.svg"
    alt="bag"
    width="16"
    height="16"
    className="w-4 h-4"
  />
);

export const SettingIcon = () => (
  <img
    src="/assets/icons/setting.svg"
    alt="setting"
    width="16"
    height="16"
    className="w-4 h-4"
  />
);

export const BoltIcon = () => (
  <img
    src="/assets/icons/bolt.svg"
    alt="bolt"
    width="16"
    height="16"
    className="w-4 h-4"
  />
);

export const ArrowIcon = ({ isExpanded = false }) => (
  <img
    src="/assets/icons/arrow.svg"
    alt="arrow"
    width="16"
    height="16"
    className={`w-4 h-4 transition-transform duration-200 ${
      isExpanded ? "rotate-0" : "rotate-180"
    }`}
  />
);

// 內建 SVG 圖標組件
export const Plus = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

export const Trash2 = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <polyline points="3,6 5,6 21,6"></polyline>
    <path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
    <line x1="10" y1="11" x2="10" y2="17"></line>
    <line x1="14" y1="11" x2="14" y2="17"></line>
  </svg>
);

export const Menu = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);
